import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useMemo } from "react";
import { customYearsArray, DEPRECATED_CustomSelect, getNewDaysArray, monthsArray, } from "../../components/DEPRECATED_CustomSelect";
import { useFormContext } from "../../components/Form";
import { useConfig } from "../../providers/useConfig";
import { useTranslations } from "../../providers/useTranslations";
import { getDaysInMonth } from "../../utils/date";
import styles from "./DateDropdown.module.scss";
export const DateDropdown = memo(({ fieldName, dropdownFieldPrefix, yearsRange, isDateChangeRestricted = false }) => {
    const { watch, setValue, register } = useFormContext();
    const { __ } = useTranslations();
    const { dobFormType } = useConfig();
    const isReversedDropdowns = dobFormType === "dropdowns_empty_reversed" || dobFormType === "dropdowns_filled_reversed";
    const dobDay = watch(`${dropdownFieldPrefix}.dobDay`);
    const dobMonth = watch(`${dropdownFieldPrefix}.dobMonth`);
    const dobYear = watch(`${dropdownFieldPrefix}.dobYear`);
    const selectedYear = dobYear?.value;
    const selectedMonth = dobMonth?.value;
    const selectedDay = dobDay?.value;
    const daysInSelectedMonth = useMemo(() => {
        const daysInMonth = getDaysInMonth(selectedMonth, selectedYear);
        const daysArray = getNewDaysArray(daysInMonth);
        if (selectedDay > daysInMonth) {
            setValue(`${dropdownFieldPrefix}.dobDay`, daysArray.at(-1));
        }
        return daysArray;
    }, [dropdownFieldPrefix, selectedDay, selectedMonth, selectedYear, setValue]);
    useEffect(() => {
        const isDobSet = dobDay && dobMonth && dobYear;
        if (isDobSet) {
            setValue(fieldName, `${dobDay?.value}.${dobMonth?.value}.${dobYear?.value}`);
            return;
        }
        setValue(fieldName, "");
    }, [dobDay, dobMonth, dobYear, fieldName, setValue]);
    useEffect(() => {
        register(fieldName);
    }, [register]);
    const dobDropdowns = [
        _jsx("div", { className: `${styles.optionsBlock} ${styles.dobDay}`, children: _jsx(DEPRECATED_CustomSelect, { inputId: "dobDaySelectInput", dataTestId: "dobDaySelectInput", isSearchable: false, name: `${dropdownFieldPrefix}.dobDay`, "aria-label": __("auth.age_verification.method_fields.dob_day.select_placeholder"), placeholder: __("auth.age_verification.method_fields.dob_day.select_placeholder"), options: daysInSelectedMonth, isDisabled: isDateChangeRestricted }) }, "dayDobDropdown"),
        _jsx("div", { className: `${styles.optionsBlock} ${styles.dobMonth}`, children: _jsx(DEPRECATED_CustomSelect, { inputId: "dobMonthSelectInput", dataTestId: "dobMonthSelectInput", isSearchable: false, name: `${dropdownFieldPrefix}.dobMonth`, "aria-label": __("auth.age_verification.method_fields.dob_month.select_placeholder"), placeholder: __("auth.age_verification.method_fields.dob_month.select_placeholder"), options: monthsArray(__), isDisabled: isDateChangeRestricted }) }, "monthDobDropdown"),
        _jsx("div", { className: `${styles.optionsBlock} ${styles.dobYear}`, children: _jsx(DEPRECATED_CustomSelect, { inputId: "dobYearSelectInput", dataTestId: "dobYearSelectInput", isSearchable: false, name: `${dropdownFieldPrefix}.dobYear`, "aria-label": __("auth.age_verification.method_fields.dob_year.select_placeholder"), placeholder: __("auth.age_verification.method_fields.dob_year.select_placeholder"), options: yearsRange || customYearsArray(10, 10), isDisabled: isDateChangeRestricted }) }, "yearDobDropdown"),
    ];
    return (_jsx("div", { className: styles.dobSelectBlock, children: isReversedDropdowns ? dobDropdowns.toReversed() : dobDropdowns }));
});
//# sourceMappingURL=DateDropdown.js.map